var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRightIcon } from '@heroicons/react/solid';
import { classNames } from '../../../..';
import { RoundIcon } from '../../../round-icon/round-icon';
import StatusChip from '../../../status-chip/status-chip';
import * as stackedListStyles from '../../stacked-list.styles';
import * as styles from './title-list-item.styles';
export function TitleListItem(_a) {
    var item = _a.item, onClickItem = _a.onClickItem;
    return (_jsx("div", __assign({ className: classNames(styles.titlelistItemContainer, item.classNames), onClick: function () {
            if (!!item.onActionClick)
                item.onActionClick();
            else if (!!onClickItem)
                onClickItem(item);
        } }, { children: _jsxs("div", __assign({ className: styles.contentWrapper }, { children: [_jsxs("div", __assign({ className: stackedListStyles.textRowsWrapper }, { children: [_jsx(RoundIcon, { icon: item.titleIcon, className: classNames('mr-4', item.titleIconClassName) }), _jsx("div", __assign({ className: stackedListStyles.paragraphWrapper }, { children: _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("h2", __assign({ className: styles.title }, { children: item.title })), _jsx("h4", __assign({ className: styles.description }, { children: item.description }))] })) }))] })), item.chipConfig && (_jsx("div", { children: _jsx(StatusChip, { backgroundColour: item.chipConfig.colorPalette.backgroundColour, borderColour: item.chipConfig.colorPalette.borderColour, textColour: item.chipConfig.colorPalette.textColour, text: item.chipConfig.text }) })), _jsx(ChevronRightIcon, { className: styles.titleChevron })] })) })));
}
export default TitleListItem;
//# sourceMappingURL=title-list-item.js.map